import { render, staticRenderFns } from "./VaccinationTypePanel.vue?vue&type=template&id=5ce5aea4&scoped=true&"
import script from "./VaccinationTypePanel.vue?vue&type=script&lang=js&"
export * from "./VaccinationTypePanel.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationTypePanel.vue?vue&type=style&index=0&id=5ce5aea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5aea4",
  null
  
)

export default component.exports